"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _fetchHelper = require("@eig-builder/core-utils/helpers/fetch-helper");

var _useDataApi = require("@eig-builder/core-utils/hooks/useDataApi");

var _keys = _interopRequireDefault(require("lodash/keys"));

var _every = _interopRequireDefault(require("lodash/every"));

var _get = _interopRequireDefault(require("lodash/get"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _values = _interopRequireDefault(require("lodash/values"));

var _indexOf = _interopRequireDefault(require("lodash/indexOf"));

var _find = _interopRequireDefault(require("lodash/find"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

/**
 * Helps to resolve the options, this api will be used for select, radio fields
 *
 * @class FieldOptionsHelper
 */
var FieldOptionsHelper = /*#__PURE__*/function () {
  function FieldOptionsHelper() {
    (0, _classCallCheck2["default"])(this, FieldOptionsHelper);
  }

  (0, _createClass2["default"])(FieldOptionsHelper, null, [{
    key: "getOptionsUrlToLoad",
    value: function getOptionsUrlToLoad(fields, field, values) {
      var optionsUrl = field.options_url; // Get new information
      // replace urls with field values

      var refsToWatch = FieldOptionsHelper._getRefsFromUrl(optionsUrl); // check if all refToWach are avaible in activeFieldsValues other wise return empty list, make no sence to resolve the url


      var allRequiredValuesAreSet = (0, _every["default"])(refsToWatch, function (refName) {
        var field = (0, _find["default"])(fields, function (obj) {
          return obj.name === refName;
        });
        return (0, _keys["default"])(values).indexOf(field.fieldId) !== -1 && values[field.fieldId] !== undefined && values[field.fieldId] !== null && values[field.fieldId] !== '';
      });

      if (!allRequiredValuesAreSet) {
        return null;
      }

      optionsUrl = FieldOptionsHelper._urlFormat(fields, optionsUrl, values);
      return optionsUrl;
    }
    /**
     * Get the options promise, it will resolve when the options are available or when the api call is finished
     *
     * @static
     * @param {object} field object
     * @param {object} schema object
     * @returns {promise} will return array of options, {label, value}
     *
     * @memberOf FieldOptionsHelper
     */

  }, {
    key: "getOptions",
    value: function () {
      var _getOptions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(optionsUrl, field) {
        var api,
            forceFetch,
            useApiGateway,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                api = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : _urlHelper.siteNames.API;
                forceFetch = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
                useApiGateway = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
                return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(resolve) {
                    var optionsUrlCanUseCdn, fetchOptions, url, matches, matchesNoGw, cacheKey, hit, response, obj;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            optionsUrlCanUseCdn = field.options_url_can_use_cdn;
                            fetchOptions = {
                              credentials: optionsUrlCanUseCdn ? 'omit' : 'include'
                            }; // support jwt authetication

                            if (_fetchHelper.globalModifyHeader && (0, _isFunction["default"])(_fetchHelper.globalModifyHeader)) {
                              fetchOptions.headers = {};
                              (0, _fetchHelper.globalModifyHeader)(fetchOptions.headers);
                            }

                            if (!(0, _isEmpty["default"])(optionsUrl) && optionsUrl[0] === '{') {
                              // Try to check if the options url has specified the endpoint for the gateway:
                              // {gw:email-marketing}/v1.0/localization/countries/US/states/lookup
                              matches = optionsUrl.match(/{gw:(.+?)}/);
                              matchesNoGw = optionsUrl.match(/{(.+?)}/);

                              if (matches) {
                                url = (0, _urlHelper.api)(optionsUrl.substr(matches[0].length), matches[1]);
                              } else if (matchesNoGw) {
                                url = (0, _urlHelper.api)(optionsUrl.substr(matchesNoGw[0].length));
                              }
                            } // If no url is set, try if we need to use the api gateway


                            if (!url && useApiGateway) {
                              // When we use the API gateway, the api field of the property editor can be used to select the api which we need for the gateway
                              url = (0, _urlHelper.api)(optionsUrl, api === _urlHelper.siteNames.API ? undefined : api);
                            } // And last step, if we still don't have an url, use the normal flow


                            if (!url) {
                              url = (0, _urlHelper.resolveUrl)(api, optionsUrl, {
                                useCdn: optionsUrlCanUseCdn
                              });
                            }

                            cacheKey = JSON.stringify({
                              url: url,
                              fetchOptions: fetchOptions
                            }); // Check if we can use the cache or that we are forced to fetch the resource again

                            if (!(forceFetch !== true)) {
                              _context.next = 12;
                              break;
                            }

                            hit = (0, _useDataApi.getFromCache)(cacheKey);

                            if (!hit) {
                              _context.next = 12;
                              break;
                            }

                            resolve(hit);
                            return _context.abrupt("return");

                          case 12:
                            _context.next = 14;
                            return (0, _fetch["default"])(url, fetchOptions);

                          case 14:
                            response = _context.sent;
                            _context.next = 17;
                            return response.json();

                          case 17:
                            obj = _context.sent;
                            // Exclude self, example: Store - Categories - parent lookup, you don't want to select yourself als the parent.
                            console.log('exclude_self in options not working'); // if (field['exclude_self'] && schema && schema.values && schema.values.id) {
                            //   obj = obj.filter(item => {
                            //     return item.value !== schema.values.id
                            //   })
                            // }

                            (0, _useDataApi.setCache)(cacheKey, obj);
                            resolve(obj);

                          case 21:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getOptions(_x, _x2) {
        return _getOptions.apply(this, arguments);
      }

      return getOptions;
    }()
  }, {
    key: "getMatches",
    value: function getMatches(string, regex, index) {
      index || (index = 1); // default to the first capturing group

      var matches = [];
      var match = regex.exec(string);

      while (match != null) {
        matches.push(match[index]);
        match = regex.exec(string);
      }

      return matches;
    }
  }]);
  return FieldOptionsHelper;
}();

FieldOptionsHelper._getRefsFromUrl = function (url) {
  var matches = FieldOptionsHelper.getMatches(url, /{([a-zA-Z0-9_]+)}/g, 0);
  matches = (0, _filter["default"])(matches, function (item) {
    return (0, _indexOf["default"])((0, _values["default"])(_urlHelper.siteNames), item) === -1;
  });
  return matches;
};

FieldOptionsHelper._urlFormat = function (fields, url, fieldValues) {
  return url.replace(/{([a-zA-Z0-9_]+)}/g, function (match, fieldName) {
    if ((0, _indexOf["default"])((0, _values["default"])(_urlHelper.siteNames), fieldName) !== -1) {
      return match;
    }

    var field = (0, _find["default"])(fields, function (obj) {
      return obj.name === fieldName;
    });
    return (0, _get["default"])(fieldValues, field.fieldId);
  });
};

var _default = FieldOptionsHelper;
exports["default"] = _default;